<template>
    <div id="main-container">

        <div id="batch-data-container">
            <!-- loading spinner -->
            <div v-if="!batchPlaybackDataLoaded" id="live-data-loading" style="text-align: center;">
                <div class="lds-facebook">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
                <div>Loading batch stats...</div>
            </div>

            <div v-if="batchPlaybackDataLoaded">
                <div id="Title">
                    <h3>Batch Playback - Device: {{ item.id }} Batch: {{ BatchID }}</h3>
                </div>
                <div id="charts-container">
                    <highcharts :options="batchPlaybackChartOptions" :updateArgs="updateArgs"></highcharts>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'BatchPlayback',
    components: {
    },
    data: function () {
        return {
            batchPlaybackDataLoaded: false,

            refreshBatchDataIntervalID: null,
            refreshBatchDataActive: true,

            batchPlaybackChartSeries: [],

            updateArgs: [true, true, { duration: 1000 }],
            batchPlaybackChartOptions: {
                chart: {
                    type: 'spline',
                    marginRight: 80, // like left
                    height: '50%',
                    zoomType: 'x',
                    resetZoomButton: {
                        position: {
                            // align: 'right', // by default
                            // verticalAlign: 'top', // by default
                            x: 0,
                            y: -30,
                        },
                    },
                },
                time: { useUTC: false, timezone: 'Australia/Melbourne', },
                rangeSelector: { enabled: false, },
                title: {
                    text: 'Device Trends'
                },
                exporting: { enabled: true, showTable: false, filename: 'BatchReplay_' + this.item.id + '_' + this.BatchID },
                series: this.batchPlaybackChartSeries,
                // xAxis: [{ type: 'datetime', title: { text: 'Time'}, }],
                xAxis: [{title: {text: "ElapsedTime (s)"}}],
                yAxis: [ { opposite: false, title: { text: 'Trends'}}, { opposite: true, title: { text: 'Pump Output'}}],
            },
        };
    },
    props: ['item', 'BatchID'],
    mounted() {
        this.refreshBatchData();

        this.refreshBatchDataIntervalID = setInterval(() => {
            if (this.refreshBatchDataActive) {
                this.refreshBatchData()
            }
        }, 60000) // 1 min    
    },
    methods: {
        beforeDestroy() {
            this.batchPlaybackChartSeries = null;
            clearInterval(this.refreshBatchDataIntervalID);
        },

        async refreshBatchData() {

            let url = process.env.VUE_APP_MULE_PROXY_API_URI;

            var data = {
                "endpoint": "/api/devices/" + this.item.id + "/data/batches/" + this.BatchID + "/playback"
            };

            data = JSON.stringify(data);

            let headers = {
                'Content-Type': 'application/json;charset=utf-8',
                'authorization': localStorage.idtoken
            };

            try {
                const response = await this.$http.post(
                    url,
                    data,
                    { headers: headers }
                );

                var pids_lc_flow_pid_pv = []
                var analogs_ht_sct_scaled = []
                var analogs_lc_lrt_scaled = []
                var analogs_lt_dst_scaled = []
                var analogs_lt_scp_scaled = []
                var analogs_lt_sct_scaled = []
                var pids_lc_flow_pid_out = []

                for (var i = 0; i < response.data.length; i++) {
                    var element = response.data[i]

                    //  var curTrend = [new Date(element.t_stamp).toLocaleString('en-US', { timeZone: 'Australia/Melbourne' }), element.floatvalue.toFixed(1)].map(Number);
                    //var curTrend = [element.t_stamp, element.floatvalue.toFixed(1)].map(Number);
                    var curTrend = [element.ElapsedTime, element.floatvalue.toFixed(1)].map(Number);
                    
                    if (element.TagPathCleaned == 'pids_lc_flow_pid_pv') pids_lc_flow_pid_pv.push(curTrend)
                    if (element.TagPathCleaned == 'analogs_ht_sct_scaled') analogs_ht_sct_scaled.push(curTrend)
                    if (element.TagPathCleaned == 'analogs_lc_lrt_scaled') analogs_lc_lrt_scaled.push(curTrend)
                    if (element.TagPathCleaned == 'analogs_lt_dst_scaled') analogs_lt_dst_scaled.push(curTrend)
                    if (element.TagPathCleaned == 'analogs_lt_scp_scaled') analogs_lt_scp_scaled.push(curTrend)
                    if (element.TagPathCleaned == 'analogs_lt_sct_scaled') analogs_lt_sct_scaled.push(curTrend)
                    if (element.TagPathCleaned == 'pids_lc_flow_pid_out') pids_lc_flow_pid_out.push(curTrend)
                }

                this.batchPlaybackChartSeries = [{
                    name: 'Flow Actual (L/min)',
                    data: (pids_lc_flow_pid_pv.length == 0 ? [] : pids_lc_flow_pid_pv),
                    yaxis: 0,
                    type: 'line'
                },
                {
                    name: 'Liquid Temp (°C)',
                    data: (analogs_lc_lrt_scaled == 0 ? [] : analogs_lc_lrt_scaled),
                    yaxis: 0,
                    type: 'line'
                },
                {
                    name: 'LT Supply Temp (°C)',
                    data: (analogs_lt_sct_scaled == 0 ? [] : analogs_lt_sct_scaled),
                    yaxis: 0,
                    type: 'line'
                },
                {
                    name: 'Pump Output',
                    data: (pids_lc_flow_pid_out == 0 ? [] : pids_lc_flow_pid_out),
                    yAxis: 1,
                    type: 'column',
                }];

                this.batchPlaybackChartOptions.series = this.batchPlaybackChartSeries;
                this.batchPlaybackDataLoaded = true;

                console.log("Batch playback data:")
                console.log(this.batchPlaybackChartOptions.series)
            }
            catch (error) {
                console.log(error);
            }
        },
    },
};
</script>

<style>
div#charts-container {
    min-width: 100%;
    min-height: 100%;
}
</style>